import React, { Component } from 'react';
import './Champion.css';
import Entity from './Entity';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';

export default class Champion extends Component {

  state = { tooltip: null }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  curseIcon (curse) {

    const name = curse.translations?.en?.name || curse.name || curse.key;
    return curse.img || "/images/statuses/" + name + ".png";
  }

  render () {

    let scale = undefined;
    if (this.props.src.champion)
      scale = this.props.src.champion.scale;
    else if (this.props.src.model && this.props.src.model.scale) {
      let scales = this.props.src.model.scale;
      for (let s of scales) {
        if (s.from > this.props.src.level)
          break;
        scale = s.value;
      }
    }

    let className = "game-champion game-champion-" + this.props.src.model.key;
    if (this.props.src.model.key === 5)
      className += this.props.src.hasStatus && this.props.src.hasStatus('facing-back') ? ' game-champion-back' : ' game-champion-forward';

    let lifeColor = "";
    if (this.props.src.champion && this.props.src.champion.getPassive("noheal"))
      lifeColor = "noheal";

    const champion = this.props.src.champion || this.props.src;
    const curses = champion.curses || [];
    const corrupted = curses.some(curse => curse.key === "corruption");
    const slimeBody = curses.some(curse => curse.key === "slime-body");
    const darkness = curses.some(curse => curse.key === "darkness");
    if (corrupted)
      className += " game-champion-corrupted";
    if (slimeBody)
      className += " game-champion-slime-body";
    if (darkness)
      className += " game-champion-darkness";
    const curseWidth = scale ? { width: (33.6 * scale) + "vh" } : undefined;

    return (
      <div className={className}>
        {
          curses.length > 0 &&
          <div className="game-champion-curses" style={curseWidth}>
            {
              curses.map((curse, index) =>
                <div id={"curse-" + index} key={"curse-" + index} className="game-champion-curse-wrapper">
                  <div className="game-champion-curse" onPointerDown={e => this.toggleTooltip(index + "-curse", e.pointerType === "touch")}>
                    <Img className="game-champion-curse-img" src={this.curseIcon(curse)}/>
                  </div>
                  {
                    curse.name &&
                    <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === index + "-curse"} target={"curse-" + index} toggle={() => this.toggleTooltip(index + "-curse")}><b>{curse.name}</b><br/>{curse.effect}</Tooltip>
                  }
                </div>
              )
            }
          </div>
        }
        <Entity onSelect={this.props.onSelect} src={this.props.src} scale={scale} lifeColor={lifeColor}/>
        {
          corrupted &&
          <div className="game-champion-corruption-particles">
            {
              Array.from({ length: 12 }, (_, index) => <div key={"corruption-particle-" + index} className="game-champion-corruption-particle"/>)
            }
          </div>
        }
      </div>
    );
  }
}

